import ApiService from '@/services/ApiService';

const firstNamespace = 'students';
const secondNamespace = 'references';

const find = (studentId, id, options, callback, errorCallback) => {
    ApiService.get(`${firstNamespace}/${studentId}/${secondNamespace}/${id}`, options, callback, errorCallback);
};

const findAll = (studentId, options, callback, errorCallback) => {
    ApiService.get(`${firstNamespace}/${studentId}/${secondNamespace}`, options, callback, errorCallback);
};

const create = (studentId, data, callback, errorCallback) => {
    ApiService.post(`${firstNamespace}/${studentId}/${secondNamespace}`, data, callback, errorCallback);
};

const update = (studentId, id, data, callback, errorCallback) => {
    // TODO: make into put when workaround for formdata is no longer needed
    ApiService.post(`${firstNamespace}/${studentId}/${secondNamespace}/${id}`, data, callback, errorCallback, { headers: { 'Content-Type': 'multipart/form-data' } });
};

const remove = (studentId, id, options, callback, errorCallback) => {
    ApiService.remove(`${firstNamespace}/${studentId}/${secondNamespace}/${id}`, options, callback, errorCallback);
};

export default {
    find,
    findAll,
    create,
    update,
    remove,
};



// WEBPACK FOOTER //
// ./src/taskflex/students/services/ReferenceService.js